import { PdfImage } from "./pdf-image";

export class PdfImages {
	Images:PdfImage[] = [];

	public constructor(data:any){
		this.Images = (data.Images || []).map((d:any)=>new PdfImage(d));
	}
}